import { z } from "zod";

export const cpaSchema = z.object({
  // Personal Information
  fullName: z.string().min(2, "Full name must be at least 2 characters").max(100),
  email: z.string().email("Invalid email address").max(255),
  phone: z.string().min(10, "Phone must be at least 10 characters").max(20),
  
  // Professional Information
  firmName: z.string().min(2, "Firm name required").max(100),
  licenseNumber: z.string().min(5, "License number required").max(50),
  yearsOfExperience: z.string().min(1, "Years of experience required"),
  
  // Location & Jurisdiction
  country: z.string().min(1, "Country required"),
  province: z.string().min(1, "Province/State required"),
  city: z.string().min(2, "City required").max(100),
  
  // Specialties
  specialties: z.string().min(10, "Please describe your specialties (min 10 characters)").max(500),
  
  // Services Offered
  taxPreparation: z.boolean(),
  auditing: z.boolean(),
  businessConsulting: z.boolean(),
  financialPlanning: z.boolean(),
  
  // Additional Information
  certifications: z.string().max(500).optional(),
  languages: z.string().max(200).optional(),
  availabilityHours: z.string().max(200).optional(),
  notes: z.string().max(1000).optional(),
  
  // Terms
  agreeToTerms: z.boolean().refine((val) => val === true, {
    message: "You must agree to the terms and conditions",
  }),
});

export type CPAFormData = z.infer<typeof cpaSchema>;
